import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

import { ContractDay } from '@models/index';
import { StaffTaskCreate } from '@models/staff-task/staff-task-create';

import { HttpService } from '@services/http.service';

import { EndpointParams } from '@models/utils/endpoint-params';
import { ActionTask, ServiceBookStatus } from '@enumerates/index';

@Injectable({
    providedIn: 'root'
})
export class ContractsService extends HttpService {
    private readonly defaultEndpointParams: EndpointParams = { app: 'member', version: 3 };

    private contractsSubject = new BehaviorSubject<ContractDay[]>([]);
    private isLoadingDataSubject = new BehaviorSubject<boolean>(true);

    readonly contracts = this.contractsSubject.asObservable();
    readonly loadingData = this.isLoadingDataSubject.asObservable();

    book(staffTaskCreate: StaffTaskCreate): Observable<any> {
        return new Observable<ServiceBookStatus>(
            observable => {
                this.post(`customer/services/${staffTaskCreate.idService}/schedules`, this.defaultEndpointParams,
                    staffTaskCreate, this.noShowErrorNotification).subscribe(
                    () => observable.next(ServiceBookStatus.success),
                    (err) => {
                        if (err != null && err.error != null && err.error.errors != null
                            && err.error.errors.length > 0) {
                            observable.next(err.error.errors[0]);
                        } else {
                            observable.next(ServiceBookStatus.failed);
                        }
                    }
                );
            }
        );
    }

    cancelBook(idScheduleService: string, idService: string, action: ActionTask): Observable<boolean> {
        return new Observable<boolean>(
            observable => {
                this.put(`customer/services/${idService}/schedules/cancel`, this.defaultEndpointParams, { idScheduleService, action }).subscribe(
                    () => observable.next(true),
                    () => observable.next(false)
                );
            }
        );
    }
}
